<template>
    <div>
        <view-item v-if="!!item" :item="item" @success="alertSuccess" @delete-item="deleteType"
            @cancel="item = false" @error="showError"></view-item>

        <list-items v-else :title="$translate('request_categories')" :items="categories" @show-item="showItem" ref="table">
            <b-button id="add-category-btn" block variant="primary" v-if="hasPermissionCreate" @click="item = {}"><img v-b-tooltip.hover
                    :title="$addLabel()" src="@/assets/images/icon/blue-add.svg" /></b-button>
        </list-items>
    </div>
</template>

<script>
import popupMixins from '@/mixins/popupMixins'
import utilityMixins from '@/mixins/utilityMixins'
import permissionsMixins from '@/mixins/permissionsMixins'
import errorHandlingMixins from '@/mixins/errorHandlingMixins'

import ListItems from './ListItems'
import ViewItem from './ViewItem'

export default {
    name: 'RequestCategories',
    components: {
        ListItems,
        ViewItem,
    },
    mixins: [
        popupMixins,
        utilityMixins,
        permissionsMixins,
        errorHandlingMixins,
    ],
    data: () => {
        return {
            item: null,
        }
    },
    mounted() {
        // this.doSearch()
    },
    computed: {
        componentName() { return this.$translate('request_category') },
        categories() {
            const categories =
                this.$store.state.requestCategory.categories || []
            console.log('categories', categories)
            return categories
        },
        user_permissions() {
            return this.$store.getters.user_permissions
        },
    },

    methods: {
        async doSearch() {
            await this.$store.dispatch('requestCategory/fetchAll')
        },

        showItem(id) {
            const item = this.categories.find(x => x.id === id)
            this.item = {
                ...item
            }
        },

        alertSuccess(action, message) {
            console.log(action, message,"messgaeAlert");
            this.genericToast(
                this.componentName,
                this.$translate(action),
                'success',
                `${this.componentName
                } ${message}`
            )
            this.item = null
            this.doSearch()
        },

        showError(error) {
            this.genericToast(
                this.componentName,
                this.$translate('error'),
                'danger',
                `${error.message}`
            )

        },
    },
}
</script>

<style></style>
